
const isTest = 0//1测试0正式
const testApi = `http://192.168.110.21:9091/rest/v1.0`//测试地址  9086美托美育 9081美托美育 9085斑比之家
// const testApi = `http://8.140.252.239:9091/rest/v1.0`//测试地址  9086美托美育 9081美托美育 9085斑比之家
// const testApi = `http://192.168.1.109:9091/rest/v1.0`//测试地址  9086美托美育 9081美托美育 9085斑比之家
// const onLineApi = `https://www.nicetuoyu.com/ys/rest/v1.0`//正式地址
const onLineApi = `https://www.17lita.com/ys/rest/v1.0`//正式地址
const ysApi = isTest == 1 ? testApi : onLineApi
export default ysApi